import { BcsInfo } from "../../utils/bcs-status";

// Pastille de statut de facturation électronique. Même gabarit que les
// pastilles « Validé » / « À traiter » des tables, mais en styles intégrés :
// le composant ne dépend d'aucune feuille CSS importée ailleurs.
// La phrase explicative passe en infobulle — la place manque dans une ligne.
export default function BcsStatusBadge({
  info,
  showDetail = false,
}: {
  info?: BcsInfo;
  // Sur un écran de détail, la phrase explicative s'affiche sous la pastille
  // au lieu de rester cachée dans l'infobulle.
  showDetail?: boolean;
}) {
  if (!info) {
    return (
      <span className="text-muted" title="Hors facturation électronique">
        —
      </span>
    );
  }
  const pill = (
    <p
      className="mb-0"
      title={info.detail}
      style={{
        display: "inline-block",
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: 12,
        lineHeight: "18px",
        textAlign: "center",
        color: "#ffffff",
        background: info.color,
        borderRadius: 5,
        padding: "6px 10px",
        whiteSpace: "nowrap",
      }}
    >
      {info.label}
    </p>
  );
  if (!showDetail || !info.detail) return pill;
  return (
    <div>
      {pill}
      <div className="text-muted mt-1" style={{ fontSize: 13 }}>
        {info.detail}
      </div>
    </div>
  );
}
